import { render, staticRenderFns } from "./PluginConfigDrawer.vue?vue&type=template&id=9345149c&scoped=true"
import script from "./PluginConfigDrawer.vue?vue&type=script&lang=js"
export * from "./PluginConfigDrawer.vue?vue&type=script&lang=js"
import style0 from "./PluginConfigDrawer.vue?vue&type=style&index=0&id=9345149c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9345149c",
  null
  
)

export default component.exports